import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { CfgIntegracaoEventoCliente } from '../../../model/cfg-integracao-evento-cliente.model';


@Injectable({
  providedIn: 'root'
})
export class CfgIntegracaoEventoClienteService extends DefaultService<CfgIntegracaoEventoCliente> {

  static URL = '/api/cfgintegracao/cfgintegracaoeventocliente/v1/cfgintegracaoeventocliente';

  constructor(
    public httpClient: HttpClient,
    public errorHandler: ErrorHandlerService
  ) {
      super(
        httpClient,
        errorHandler,
        CfgIntegracaoEventoClienteService.URL
      );
  }


  criarOuAtualizar(cfgIntegracaoEventoCliente: CfgIntegracaoEventoCliente): Observable<CfgIntegracaoEventoCliente> {
    return this.httpClient.post<CfgIntegracaoEventoCliente>(`${CfgIntegracaoEventoClienteService.URL}/criarOuAtualizar`, cfgIntegracaoEventoCliente, this.httpOptions)
                          .pipe(
                            catchError((err: any) => throwError(this.errorHandlerService.handle(err)))
                          );
  }  

  ativar(id: number): Observable<CfgIntegracaoEventoCliente> {
    return this.httpClient.put<CfgIntegracaoEventoCliente>(`${CfgIntegracaoEventoClienteService.URL}/${id}/ativar`, this.httpOptions)
                          .pipe(
                            catchError((err: any) => throwError(this.errorHandlerService.handle(err)))
                          );
  }  

}
